// Module
var code = "<div class=\"basket-ui__header\"> <span class=\"basket-ui__header-label\">[[YourCart]]</span> <span class=\"basket-ui__header-icon\" tabindex=\"0\"> <i class=\"material-icons-outlined\">close</i> </span> </div> <div class=\"basket-ui__content\"> </div> <div class=\"basket-ui__footer\"> </div>";
// Exports
module.exports = code;